import { Component, NgZone, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../shared/services/api.service';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';
import { PATTERNS } from '../../shared/constants/patterns.constants';

@Component({
  standalone: false,
  selector: 'app-conversion',
  templateUrl: './conversion.component.html',
  styleUrl: './conversion.component.scss'
})
export class ConversionComponent {

  count = 0;
  dataObj: any = {};
  modalRef: any;
  gridApi: any;
  content: any;
  type = 'rates';
  countries: any;
  isEdit = false;
  apiUrl: any;
  pattern = PATTERNS;

  columnDefs: ColDef[] = [
      {
      headerName: 'Action',
      field: 'action',
      width: 80,
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-primary', 'active', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye-fill"></i>';
        button.addEventListener('click', () => this.onEdit(params));
        return button;
      },
    },
    {
      headerName: 'Status',
      field: 'isActive',
      editable: false,
      filter: false,
      sortable: false,
      valueFormatter: (params) => {
        return params.value ? 'Active' : 'Inactive';
      }
    },
    {
      headerName: 'From Currency',
      field: 'fromCurrency',
      editable: false,
      filter: false,
      sortable: false,
    },
    {
      headerName: 'To Currency',
      field: 'toCurrency',
      editable: false,
      filter: false,
      sortable: false,
    },
    {
      headerName: 'Rate',
      field: 'rate',
      editable: false,
      filter: false,
      sortable: false,
    },
    {
      headerName: 'Valid From',
      field: 'validFrom',
      editable: false,
      filter: false,
      sortable: false,
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleString();
        }
        return '';
      }
    },
    {
      headerName: 'Valid To',
      field: 'validTo',
      editable: false,
      filter: false,
      sortable: false,
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleString();
        }
        return 'Present';
      }
    }
  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };


  constructor(
    private _modal: NgbModal,
    private _api: ApiService,
    private zone: NgZone
  ) { }

  ngOnInit(): void {
    const vm = this;
    vm.getCountries();
  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    }
  }

  refreshGrid() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  getCountries() {
    const vm = this;
    const type = 'country'
    const apiUrl = '/admin/get-data?type=' + type + '&_limit=500';
    vm._api.getData(apiUrl).subscribe((res: any) => {
      if (res && !res.error) {
        vm.countries = (res.data || []).sort((a: any, b: any) => {
          const nameA = a?.displayName?.toLowerCase() || '';
          const nameB = b?.displayName?.toLowerCase() || '';
          return nameA.localeCompare(nameB);
        });
      }
    });
  }


  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;

        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        if (!vm.countries?.length) {
          console.log('Countries not loaded yet');
          params.failCallback();
        }
        vm.apiUrl = '/admin/get-data?type=' + vm.type + '&_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {

            const countryMap = new Map(
              vm.countries.map((country: any) => [
                country._id,
                country.currency?.shortName || ''
              ])
            );

            const rateData = (res.data || []).map((item: any) => ({
              ...item,

              fromCurrency:
                countryMap.get(item.from?._id) || '',

              toCurrency:
                countryMap.get(item.to?._id) || '',
            }));

            vm.count = res.count;

            console.log('Countries:', vm.countries);
            console.log('Mapped Rate Data:', rateData);

            params.successCallback(rateData, res.count);
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  addNew(content: any) {
    const vm = this;
    this.isEdit = false;
    this.addError = '';
    vm.dataObj = {};
    //this.content = content;
    console.log(vm.content);
    vm.modalRef = vm._modal.open(this.content, { backdrop: 'static', size: 'lg' });
  }

  onEdit(row: any) {
    this.isEdit = true;
    this.addError = '';
    this.zone.run(() => {
      const data = row.data;
      this.dataObj = {
        _id: data._id,
        from: data.from?._id,
        to: data.to?._id,
        rate: data.rate
      };
      this.modalRef = this._modal.open(this.content, { backdrop: 'static', size: 'lg' });
    });
  }


  setContent(c: any) {
    this.content = c;
  }

  addError: string = '';

  onSubmit(flag: any) {
    this.addError = '';
    this.dataObj['type'] = this.type;
    const fromCountry = this.countries.find(c => c._id === this.dataObj.from);
    const toCountry = this.countries.find(c => c._id === this.dataObj.to);
    if (fromCountry && toCountry && fromCountry._id === toCountry._id) {
      this.addError = 'From country and To country must be different';
      return;
    }

    // Only send the fields that can be edited via the form
    // Let the backend handle versioning logic (validFrom, validTo, isActive)
    const reqObj: any = {
      type: this.type,
      from: fromCountry._id,
      to: toCountry._id,
      rate: this.dataObj.rate
    };

    // If editing, include the ID so backend knows which rate to update
    if (this.dataObj._id) {
      reqObj._id = this.dataObj._id;
    }

    const apiUrl = this.dataObj._id ? '/admin/edit-data' : '/admin/new-data';
    this._api.postData(apiUrl, reqObj).subscribe({
      next: (res: any) => {
        if (res && !res.error) {
          this.onClose();
          this.gridApi.refreshInfiniteCache();
        } else {
          this.addError = res.message || 'Error saving rate conversion';
        }
      },
      error: (err: any) => {
        this.addError = (err.error && err.error.message) || err.message || 'Error saving rate conversion';
      }
    });
  }


  onClose() {
    this.modalRef.close();
  }

}
